export const LOGIN_PARTITION = 'persist:lifenconnect';

export const DESKTOP_LOGIN = 'DESKTOP_LOGIN';

export const MAX_JOB_PROCESSING_COUNT = 5;

export const SENDER_IDENTITY_REFERENCES_LOCALSTORAGE_KEY = 'SENDER_IDENTITY_REFERENCES';

export const ROOT_WATCHPATH = 'Lifen';
export const SENDING_WATCHPATH = 'Outbox';
export const SUCCESS_DIRECTORY = 'Success';
export const ERROR_DIRECTORY = 'Error';

export const WATCHERS_POLLING_INTERVAL_DEFAULT = 2000;
export const WATCHER_WRITE_POLLING_INTERVAL = 500;
export const UPLOAD_DEFAULT_RETRY_DELAY = 1000;
export const WEBVIEW_INTERVAL = 2000;

export const LAST_APP_VIEWED_LOCALSTORAGE_KEY = 'LAST_APP_VIEWED';
